import { Section } from "../components/sections/TextSection";

export const RichTextConfig: Section = {
    row: 0,
    col: 0,
    name: 'Rich Text',
    type: 'richText',
    id: '11',
    selected: false,
    height: 60,
    width: 60,
    rowCount: 10,
    colCount: 10,
    textContent: "",
    x: 0,
    y: 0,
    isLocked: false,    
    propInfo: [
        {
            name: "RPOrder",
            inputType: 'number',
            binding: 'rporder',
            value: 0,
            label: 'Reading Order',
        },
        {
            name: 'Show Scrollbar',
            inputType: 'dropdown',
            binding: 'style.overflow',
            options: [
              { label: 'Show', value: 'auto' },
              { label: 'hide', value: 'hidden' },
            ],
            value: 'hidden',
            label: 'Scroll Visible',
        },
        {
            name:"Audio",
            inputType: 'audio',
            binding: 'audio',
            value: '',
            label: 'Audio',
        },
        {
            name: 'Border Radius',
            inputType: 'number',
            binding: 'style.borderRadius',
            value: '0px',
            label: 'Border Radius',
        },
        {
            name: "Rotation",
            inputType: 'number',
            binding: 'style.transform',
            value: 0,
            label: 'Rotation',
        },        
        {
            name: 'padding',
            inputType: 'number',
            binding: 'style.padding',
            value: '0',
            hidden: false,
            label: 'Padding',
        },
        {
            name: "background", 
            inputType: 'gradientcolor',
            binding: 'style.background',
            value: '',
            label: 'Background',
        },
        {
            name: "innerHTML",
            inputType: 'text',
            binding: 'innerHTML',
            hidden: true,
            value: '',
            label: 'Rich Text Content',
        },
        {
            name: "delta",
            inputType: 'none',
            binding: 'delta',
            value: {},
            label: 'Rich Text Content',
        }
    ]
};
